module.exports = __webpack_public_path__ + "img/IMG_1155.7755f56f.png";